<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{ caption }}<strong v-if="required" class="required">*</strong>
        </template>
        <template slot="input">
            <div style="display: flex; flex-flow: row; align-items: center;">
                <small-icon-button icon="map" @press="showModal" />

                <input type="text" :class="{ 'input-component': true, active: active }" v-model="showedText" :disabled="disabled" />

                <v-modal name="mapModal">
                    <div class="modal-mask">
                        <div class="modal-wrapper">
                            <div class="modal-container">
                                <div class="modal-body">
                                    <div style="height: 800px; width: 100%">
                                        <l-map :id="mapCursorStyle" :zoom="zoom" :center="center" @click="addMarker">
                                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                            <l-marker v-for="(marker, index) in markers" :lat-lng="marker" :key="index"></l-marker>
                                            <l-circle v-if="radiusValue && markers.length" :lat-lng="circle.center" :radius="circle.radius" :color="circle.color">
                                            </l-circle>
                                        </l-map>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <simple-horizontal-layout>
                                        <empty />
                                        <simple-button @press="choosePossition">OK</simple-button>
                                        <simple-button v-if="!positionEditabled" @press="editPosition">Choose new position</simple-button>
                                        <simple-button v-else @press="editPosition">Selecting postion</simple-button>
                                        <simple-button @press="removeMarker">CLEAR position</simple-button>
                                        <simple-button @press="cancelPossition">{{$t("cancel")}}</simple-button>
                                    </simple-horizontal-layout>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-modal>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
import FormInputLayout from './FormInputLayout';
import SmallIconButton from '../button/SmallIconButton';
import SimpleButton from '../button/SimpleButton';
import SimpleHorizontalLayout from '../layout/SimpleHorizontalLayout';
import Empty from '../layout/Empty';
import { Vue } from 'vue';
export default {
    name: 'FormGeoInput',
    components: { FormInputLayout, SmallIconButton, Empty, SimpleHorizontalLayout, SimpleButton },
    props: {
        value: Object,
        caption: String,
        disabled: Boolean,
        required: Boolean,
        helpItemCode: String,
    },
    data: function() {
        return {
            internalValue: '',
            finalValue: '',
            active: false,
            color: 'red',
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            defaultZomm: true,
            markers: [],
            positionEditabled: false
        };
    },
    mounted() {
        this.longtitude && this.latitude && this.markers.push({ lat: this.latitude, lng: this.longtitude });
    },
    computed: {
        longtitude: function() {
            return this.value?.longtitude ?? 0;
        },
        latitude: function() {
            return this.value?.latitude ?? 0;
        },
        name: function() {
            return this.value?.name ?? "";
        },
        radiusValue : function() {
            return this.value?.radiusValue ?? 0;
        },
        center: function() {
            return this.longtitude && this.latitude ? [this.latitude, this.longtitude] : [49.816720843571765, 15.337081892139228]; //zhruba nad cz
        },
        showedText: function() {
            if (this.name) return this.name;
            else if ((this.longtitude || this.longtitude === 0) && (this.latitude || this.latitude === 0))
                return ' LTT: ' + Number(this.latitude).toFixed(3) + ' LNG: ' + Number(this.longtitude).toFixed(3);
            else return 'N/A';
        },
        mapCursorStyle: function() {
            return this.positionEditabled ? 'map-style' : '';
        },
        zoom: function() {
            return !this.longtitude || !this.latitude ? 2 : 7;
        },
        circle: function() {
            return {
                center: this.markers[0],
                radius: this.radiusValue * 1000,
                color: 'red'
            };
        }
    },
    methods: {
        addMarker(event) {
            if (this.positionEditabled) {
                this.markers = [event.latlng];
                this.positionEditabled = false;
            }
        },
        removeMarker() {
            this.markers.splice(0, 1);
        },
        choosePossition() {
            if (this.markers.length) this.$emit('input', {...this.value, longtitude: this.markers[0].lng, latitude: this.markers[0].lat });
            else this.$emit('input', { ...this.value,longtitude: '', latitude: '' });
            this.positionEditabled = false;
            this.$modal.hide('mapModal');
        },
        cancelPossition() {
            this.positionEditabled = false;
            this.$modal.hide('mapModal');
        },
        editPosition() {
            this.positionEditabled = !this.positionEditabled;
        },
        showModal() {
            this.$modal.show('mapModal');
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../styles/global';
.input-component {
    background-color: transparent;
    border: none;
    background-color: var(--input-background-color);
    border-radius: 5px;
    color: var(--input-font-color);
    padding: 2px 10px 2px 10px;
    outline: none;
    width: 100%;
    font-family: Source Sans Pro;
    margin-left: 10px;
}

.active {
    color: var(--input-active-font-color);
    background-color: var(--input-active-background-color);
    border: 1px solid var(--input-active-border-color);
}

.required {
    color: var(--accent-color);
}

#map-style {
    cursor: crosshair;
}

.modal-footer {
    padding: 16px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 70%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: $backgroundColor;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
</style>
